import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./ReviewField.module.scss";

export default function ReviewField({ label, value, suffix, showUnderscore }) {
  return (
    <Grid2>
      <Grid2 className={styles.header}>{label}</Grid2>
      <Grid2 className={styles.inputText}>
        {value}
        {showUnderscore && suffix && <span>_{suffix}</span>}
        {!showUnderscore && suffix && <span>{suffix}</span>}
      </Grid2>
    </Grid2>
  );
}